import cx from 'classnames'
import { useState } from 'react'
import useVideoQueueLength from './useVideoQueueLength'

const WaitingRoom = ({ onEnterCall }: { onEnterCall: () => Promise<void> }) => {
  const [isEntering, setIsEntering] = useState(false)

  const { queueLength, loading } = useVideoQueueLength()

  const handleEnterCall = async () => {
    try {
      setIsEntering(true)
      await onEnterCall()
    } finally {
      setIsEntering(false)
    }
  }

  if (loading) {
    return <p>Loading queue</p>
  }

  if (queueLength === 0) {
    return (
      <div className="columns">
        <div className="column is-6 is-offset-3 has-text-centered">
          <p>No calls in the queue {loading && ' (refreshing...)'}</p>
        </div>
      </div>
    )
  }

  return (
    <>
      <div className="columns">
        <div className="column is-6 is-offset-3 has-text-centered">
          <p className="mb-2">
            {queueLength || 'UNKNOWN'} calls in the queue {loading && ' (refreshing...)'}
          </p>

          <p>
            Click to enter the next call in the queue. Please check your local video preview before entering and make
            sure your audio works.
          </p>
        </div>
      </div>

      <div className="is-fullwidth is-flex is-justify-content-center">
        <div>
          <button
            onClick={handleEnterCall}
            className={cx('button is-primary is-large', {
              'is-loading': isEntering,
            })}
          >
            Enter Call
          </button>
        </div>
      </div>
    </>
  )
}

export default WaitingRoom
